import classnames from 'classnames'
import LivePlayer from 'app-live-mf/LivePlayerConsumer'

import { Transmission } from 'modules/transmission/types'

import './player.scss'

export interface PlayerProps {
  className?: string,
  embedUrl?: string,
  leadCode?: string,
  isMuxStudioLayout?: boolean,
  isHotmartProvider: boolean,
  transmission: Transmission,
  theaterMode?: boolean
}

const Player = ({ className, theaterMode, ...props }: PlayerProps) => {
  return (
    <LivePlayer
      {...props}
      className={classnames(className, 'player-mf', {
        'theater-mode': theaterMode
      })} />
  )
}

export default Player

